<template>
  <router-view />
</template>

<script>
  export default {
    name: 'InventarySystemApp',
  }
</script>
